export default __webpack_public_path__ + "static/media/demo.5feb832a.pdf";